import React from "react";

const Cart = () => {
    return(
        <div>Hola</div>
    )
  }
  
  export default Cart;